import { uploadData } from 'aws-amplify/storage'

type UploadFileParams = {
  key: string
  file: Blob | File
}

export const uploadFile = async ({
  key,
  file,
}: UploadFileParams) => {
  try {
    const task = uploadData({
      path: `public/${key}`,
      data: file,
    })
    return await task.result
  } catch (error) {
    console.error('Error uploading file:', { error, key })
    return undefined
  }
}

type UploadPictureFromURLProps = {
  url: string
  callback?: (data: unknown) => void
}

export const uploadPictureFromURL = async ({
  url,
  callback,
}: UploadPictureFromURLProps) => {
  try {
    if (!url) return
    // Trim the URL to avoid empty strings
    const trimmedURL = url.trim()
    if (!trimmedURL.length) return
    // Fetch the image and upload it
    const response = await fetch('/api/upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: trimmedURL }),
    })
    if (!response.ok) throw new Error(`Response status: ${response.status}`)
    // Get the key of the uploaded image
    const data = await response.json()
    // Add the key to the pictures list
    if (callback && data) callback(data)
    return data.key
  } catch (e) {
    console.error(e)
  }
}
